import React, { useState, useContext, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { isMobileOnly, isTablet } from 'react-device-detect';
import classNames from 'classnames';
import useMobileOrientation from '../../../hooks/useMobileOrientation';
import _ from 'lodash';

import Icon from 'src/components/Icon/Icon';
import StatsModal from '../../StatsModal/StatsModal';
import DetailHeaderContext from '../Context/DetailHeader.context';
import { RootState } from 'src/configs/store';

interface AllMarketsProps {
  /**
   * Portrayed event's information.
   */
  event: {
    countryCode: string,
    name: string,
    date: string,
    tournamentName: string,
    sportIcon: string,
    linkId: string
  },
  /**
   * URL used to go back.
   */
  backUrl?: string
}

export default function AllMarkets({ event, backUrl = '/sports-betting/prematch' }: AllMarketsProps) {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const [toggleIframe, setToggleIframe] = useState(false);
  const [showInfo, setShowInfo] = useState(false);
  const { isPortrait } = useMobileOrientation();
  const { scrolled } = useContext(DetailHeaderContext);
  const showMobileTracker = useSelector((state: RootState) => state.events.showMobileTracker);

  const name = event.name?.split('-');

  const goBack = () => {
    if (_.has(location.state, 'bottomDrawer')){
      dispatch.content.openDrawer(location.state['bottomDrawer']);
    }

    dispatch.events.setEvent({});
    history.push(backUrl);
  };

  const openNewWindow = () => {
    setToggleIframe(!toggleIframe);
  };

  const changeMatchTracker = () => {
    dispatch.events.changeMobileTracker();
  };

  useEffect(() => {
    return () => {
      dispatch.events.setEvent({});
    };
  }, []);

  return (
    <>
      <div
        className={
          classNames({
            'detail-header__header-wrapper--small' : scrolled >= 20 && !showInfo,
            'detail-header__header-wrapper': true
          })
        }
        onClick={ () => setShowInfo(!showInfo) }
      >
        <Icon icon="arrow" className="detail-header__arrow detail-header__back detail-header__back--allmarkets" onClick={ goBack } />

        <div className="detail-header__title-info detail-header__title-info--allmarkets">
          {
            name && (
              <>
                <span className="detail-header__info-text" title={ name[0] }>{ name[0] }</span>
                {
                  name.length > 1 && (
                    <span className="detail-header__info-text" title={ name[1] }>{ name[1] }</span>
                  )
                }
              </>
            )
          }
        </div>

        {
          event.linkId && (isMobileOnly || (isTablet && isPortrait)) &&
            <div className="detail-header__event-graph-box">
              <Icon icon="graph" className="detail-header__event-graph" onClick={ openNewWindow } />
              <Icon
                icon="matchtracker"
                className={
                  classNames({
                    'detail-header__event-tracker': true,
                    'detail-header__event-tracker--selected': showMobileTracker
                  })
                }
                onClick={ changeMatchTracker }
              />
            </div>
        }

        { event.sportIcon && <div className="detail-header__icon sport-icon">{ event.sportIcon }</div> }
      </div>

      {
        event.tournamentName && (
          <div
            className={
              classNames({
                'detail-header__details--small' : scrolled >= 20 && !showInfo,
                'detail-header__details': true
              })
            }
          >
            <div className="detail-header__tournament-name">{ event.tournamentName }</div>
            { event.date && <div className="detail-header__time">{ event.date }</div> }
          </div>
        )
      }
      {
        toggleIframe && event?.linkId &&
          <StatsModal linkId={ event?.linkId } toggle={ openNewWindow } type="event" />
      }
    </>
  );
}
